export default __webpack_public_path__ + "static/media/search.e7bdbbf1.svg";